import _pt from "prop-types";
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var TwitterBrand = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$ariaHidden = _ref['aria-hidden'],
      ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      title = _ref.title,
      titleId = _ref.titleId;
  var numericSize = size === 'medium' ? 16 : size === 'small' ? 14 : 12;
  return ___EmotionJSX("svg", {
    viewBox: "0 0 18 18",
    "aria-hidden": ariaHidden,
    className: className,
    height: numericSize,
    ref: ref,
    role: "img",
    width: numericSize,
    "aria-labelledby": titleId
  }, title === undefined ? ___EmotionJSX("title", {
    id: titleId
  }, 'Twitter') : title ? ___EmotionJSX("title", {
    id: titleId
  }, title) : null, ___EmotionJSX("path", {
    fill: color,
    d: "M15.864 5.35c.008.146.01.293.01.439 0 4.491-3.417 9.668-9.666 9.668A9.61 9.61 0 011 13.93c.266.031.536.047.81.047a6.819 6.819 0 004.22-1.453 3.4 3.4 0 01-3.174-2.36 3.472 3.472 0 001.534-.058 3.4 3.4 0 01-2.725-3.332V6.73a3.39 3.39 0 001.54.426A3.397 3.397 0 012.152 2.62a9.644 9.644 0 007.003 3.55A3.396 3.396 0 0112.466 2c.977 0 1.86.411 2.48 1.072a6.842 6.842 0 002.157-.825 3.41 3.41 0 01-1.494 1.88 6.796 6.796 0 001.951-.535 6.86 6.86 0 01-1.696 1.758z",
    fillRule: "evenodd"
  }));
});
TwitterBrand.propTypes = process.env.NODE_ENV !== "production" ? {
  'aria-hidden': _pt.bool,
  className: _pt.string,
  color: _pt.string,
  size: _pt.oneOf(['xsmall', 'small', 'medium']),
  title: _pt.string,
  titleId: _pt.string
} : {};
export default TwitterBrand;